import type {
	SyncedBlockPluginOptions,
	SyncedBlockEditorProps,
	SyncedBlockRendererProps,
} from '@atlaskit/editor-plugin-synced-block';
import type { SyncedBlockProvider } from '@atlaskit/editor-synced-block-provider';

interface Props {
	options: {
		dataProvider?: SyncedBlockProvider;
		getSyncedBlockEditor?: (props: SyncedBlockEditorProps) => React.JSX.Element;
		getSyncedBlockRenderer?: (props: SyncedBlockRendererProps) => React.JSX.Element;
	};
}

export function syncedBlockPluginOptions({ options }: Props): SyncedBlockPluginOptions {
	return {
		getSyncedBlockEditor: options.getSyncedBlockEditor,
		getSyncedBlockRenderer: options.getSyncedBlockRenderer,
		dataProvider: options.dataProvider,
	};
}
